import { ReadResult } from 'interfaces/queryOptions'
import { ClientChip } from 'models/clientChips'

export interface GroupChipsByOrderResult {
  groups: Record<number, Array<ReadResult<ClientChip>>>
  skipped: Array<ReadResult<ClientChip>>
}

// Chips sem relationships.order.id (ex: nunca vinculados a um pedido) não podem
// ser enviados pro updateItemStatus, que exige um orderId — ficam em `skipped`
// pra quem chamar decidir como avisar o usuário.
export function groupChipsByOrder(
  chips: Array<ReadResult<ClientChip>>
): GroupChipsByOrderResult {
  const groups: Record<number, Array<ReadResult<ClientChip>>> = {}
  const skipped: Array<ReadResult<ClientChip>> = []

  for (const chip of chips) {
    const orderId = chip.relationships?.order?.id
    if (orderId === undefined) {
      skipped.push(chip)
      continue
    }

    groups[orderId] = groups[orderId] ?? []
    groups[orderId].push(chip)
  }

  return { groups, skipped }
}
